import type { Edge } from '@xyflow/react';

export function orientFlowEdgesFromRoot({
  rootId,
  edges,
}: {
  rootId: string;
  edges: Edge[];
}): Edge[] {
  const adjacency = new Map<string, string[]>();

  for (const edge of edges) {
    const sourceNeighbors = adjacency.get(edge.source) ?? [];

    sourceNeighbors.push(edge.target);
    adjacency.set(edge.source, sourceNeighbors);

    const targetNeighbors = adjacency.get(edge.target) ?? [];

    targetNeighbors.push(edge.source);
    adjacency.set(edge.target, targetNeighbors);
  }

  const depthByNodeId = new Map<string, number>([[rootId, 0]]);
  const queue = [rootId];

  while (queue.length > 0) {
    const nodeId = queue.shift();

    if (!nodeId) {
      continue;
    }

    const depth = depthByNodeId.get(nodeId) ?? 0;

    for (const neighborId of adjacency.get(nodeId) ?? []) {
      if (depthByNodeId.has(neighborId)) {
        continue;
      }

      depthByNodeId.set(neighborId, depth + 1);
      queue.push(neighborId);
    }
  }

  return edges.map((edge) => {
    const sourceDepth =
      depthByNodeId.get(edge.source) ?? Number.POSITIVE_INFINITY;
    const targetDepth =
      depthByNodeId.get(edge.target) ?? Number.POSITIVE_INFINITY;

    if (sourceDepth <= targetDepth) {
      return edge;
    }

    return {
      ...edge,
      source: edge.target,
      target: edge.source,
    };
  });
}
